<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col sm="10">
            <h3>Envio de E-mail</h3>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-form v-on:submit.prevent="onSubmit">
          <b-row>
            <b-col cols="12">
              <b-form-group label="Tipo de envio:" v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group id="checkbox-group-1" v-model="tp_envios" autofocus :options="options"
                  :aria-describedby="ariaDescribedby" name="flavour-1"></b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <h4>Destinatários</h4>
          <b-row>
            <b-col sm="3">
              <b-form-group label="UF:">
                <b-form-select v-model="$v.form.uf_id.$model" :options="estados" class="mb-3">
                  <option selected :value="null">Selecione</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group label="Município:" :disabled="disabled_cidades">
                <b-form-select v-model="$v.form.municipio_id.$model" :options="cidades">
                  <option selected :value="null">Selecione</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group label="Nome, CNPJ Instituições:">
                <b-form-select v-model="$v.form.tb_instituicoes.$model" multiple :disabled="!validInstituicao">
                  <option selected :value="null">Selecione</option>
                  <option v-for="item in instituicoes" :value="item" :key="item.id"> {{item.nome_instituicao}}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Nome dos integrantes:">
                <b-form-select v-model="$v.form.tb_usuarios.$model" multiple :disabled="!validInstituicao">
                  <option selected :value="null">Selecione</option>
                  <option v-for="item in usuarios" :value="item" :key="item.id"> {{item.nome}} - {{item.cpf}}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="3" offset-md="3">
              <b-button block class="mt-3" variant="primary" v-on:click="adicionarDestinatarios">
                <i class="fa fa-plus"></i>&nbsp;
                <span>Adicionar</span>
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-container fluid>
                <span>
                  <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7"
                    class="table table-responsive-sm table-bordered table-striped table-sm">
                    <thead class="text-center">
                      <tr>
                        <th scope="col">UF</th>
                        <th scope="col">Município</th>
                        <th scope="col">Nome da Instituição</th>
                        <th scope="col">CNPJ</th>
                        <th scope="col">Categoria</th>
                        <th scope="col">Integrantes</th>
                        <th scope="col">Email</th>
                        <th scope="col">Ações</th>
                      </tr>
                    </thead>
                    <tbody v-if="destinatarios.length > 0" class="text-center">
                      <tr v-for="(item, index) in destinatarios" :key="index">
                        <td>{{estados[item.uf_id]}}</td>
                        <td>{{item.municipio_name}}</td>
                        <td>{{item.nome_instituicao}}</td>
                        <td>{{item.cnpj}}</td>
                        <td>{{item.categoria}}</td>
                        <td>{{item.nomes}}</td>
                        <td>{{item.emails}}</td>
                        <td style="width: 15%">
                          <a class="btn btn-sm btn-secondary action" title="Excluir"
                            @click="excluirDestinatario(index)">
                            <i class="fa fa-times"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr class="action">
                        <td colspan="6">Nenhum destinatário</td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </b-container>
            </b-col>
          </b-row>
          <h4>Dados da mensagem</h4>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Assunto: *">
                <b-input-group class="mb-6">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" class="form-control" placeholder="Assunto do email"
                    v-model="$v.form.assunto.$model" />
                  <b-form-invalid-feedback id="input1LiveFeedback1" :state="chkState('assunto')">Assunto é obrigatório.
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <div cols="12">
            <label>Corpo do E-mail: *</label>
            <b-form-textarea value="Hello, World!" v-model="$v.form.corpo_email.$model"
              placeholder="Escreva a descrição aqui..." rows="3" max-rows="6"></b-form-textarea>
            <b-form-invalid-feedback :state="descricaoValid">O campo descrição é obrigatório.</b-form-invalid-feedback>
          </div>
          <b-row>
            <b-col cols="12">
              <br />
              <label>Anexo:</label>
              <span class="icon-info" v-b-popover.hover.top="
                'Permitidos apenas imagens e arquivos .pdf'
              " title="Anexo"></span>
              <b-form-group label-for="nome-input" :state="chkState('anexo')" invalid-feedback="Anexo é obrigatório">
                <b-row>
                  <b-col cols="6">
                    <b-form-file ref="file-input" browse-text="Selecione" placeholder="Selecione o documento"
                      v-on:change="uploadDoc"></b-form-file>
                  </b-col>
                  <b-col md="3">
                    <b-button block variant="primary" v-on:click="adicionarAnexo">
                      <i class="fa fa-plus"></i>&nbsp;
                      <span>Adicionar</span>
                    </b-button>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-container fluid>
                <span>
                  <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7"
                    class="table table-responsive-sm table-bordered table-striped table-sm">
                    <thead class="text-center">
                      <tr>
                        <th scope="col">Nome do Arquivo</th>
                        <th scope="col">Ações</th>
                      </tr>
                    </thead>
                    <tbody v-if="arraAnexos.length > 0" class="text-center">
                      <tr v-for="(item, index) in arraAnexos" :key="index">
                        <td v-if="item.nome" >{{item.nome}}</td>
                        <td v-if="item.name" >{{item.name}}</td>
                        <td style="width: 15%">
                          <a class="btn btn-sm btn-secondary action" title="Excluir" @click="excluirAnexo(index)">
                            <i class="fa fa-times"></i>
                          </a>
                          <a v-if="item.path" class="btn btn-sm btn-secondary action" title="Download" @click="download(item.path)">
                            <i class="fa fa-download"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr class="action">
                        <td colspan="6">Nenhum anexo...</td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </b-container>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="3" offset-md="3">
            <b-button block variant="primary" v-on:click="onSubmit">
              <i class="fa fa-check"></i>&nbsp;
              <span>Enviar</span>
            </b-button>
          </b-col>
          <b-col md="3">
            <b-button block variant="secondary" @click="$router.go(-1)">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </span>
</template>

<script>
import 'v-markdown-editor/dist/v-markdown-editor.css'
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import miniToastr from 'mini-toastr'
import Editor from 'v-markdown-editor'
import CKEditor from 'ckeditor4-vue'
import SessionStorage from '@/services/session-storage'

miniToastr.init()
Vue.use(Editor)
Vue.use(CKEditor)

const formShape = {
  assunto: '',
  corpo_email: '',
  anexo: '',
  tb_usuarios: [],
  tb_instituicoes: null,
  uf_id: null,
  municipio_id: null,
  link: ''
}

export default {
  name: 'Cadastro',
  components: {
    AuthTemplate,
    VueSelect,
    Editor
  },
  mixins: [validationMixin],
  validations: {
    form: {
      assunto: {
        // required
      },
      corpo_email: {
        // required
      },
      tb_usuarios: {
        // required
      },
      tb_instituicoes: {
        // required
      },
      uf_id: {
        //  required
      },
      municipio_id: {
        // required
      },
      anexo: {
        // required
      }
    }
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') !== 'A') {
      this.$router.push('/')
    }
    this.$store.dispatch('buscarEstados')
  },
  data () {
    return {
      form: Object.assign({}, formShape),
      id: 0,
      imagemAtual: false,
      descricaoValid: null,
      disabled_cidades: true,
      DeleteImagens: false,
      tp_envios: [],
      usuarios: [],
      instituicoes: [],
      validInstituicao: false,
      destinatarios: [],
      arraAnexos: [],
      propsAnexo: null,
      options: [
        { text: 'Institução', value: 1 },
        { text: 'Gestor', value: 2 },
        { text: 'Tutor', value: 3 }
      ]
    }
  },
  mounted () {
    if (typeof this.$route.params.id !== 'undefined') {
      this.load(this.$route.params.id)
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    }
  },
  watch: {
    '$v.form.uf_id.$model': function () {
      if (this.form.uf_id !== null) {
        this.$store.dispatch('buscarCidadesPorEstado', this.form.uf_id)
        this.disabled_cidades = false
      } else {
        this.disabled_cidades = true
        this.form.municipio_id = null
      }
    },
    '$v.form.municipio_id.$model': function () {
      if (this.form.municipio_id !== null) {
        if (this.validInstituicao) { this.buscaInstituicoes(this.form.municipio_id) }
        if (!this.validInstituicao) { this.buscaInstituicoes(this.form.municipio_id) }
        this.usuarios = []
      }
    },
    'tp_envios': function (value) {
      if (value.includes(1)) { this.validInstituicao = true } else {
        this.validInstituicao = false
        this.form.tb_instituicoes = null
      }
    },
    '$v.form.tb_instituicoes.$model': function (value) {
      this.buscaUsuarios()
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    salvar () {
      var form = this.$v.form

      let data = {
        id: this.id,
        assunto: form.assunto.$model,
        corpo_email: form.corpo_email.$model,
        tp_envio: JSON.stringify(this.tp_envios),
        municipio_id: form.municipio_id.$model,
        uf_id: form.uf_id.$model,
        tb_instituicoes: JSON.stringify(this.destinatarios),
        tb_anexos: JSON.stringify(this.arraAnexos)
      }

      Vue.http
        .post('api/mensagens', data)
        .then((response) => {
          if (response.body.success) {
            miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
            if (this.cadastroInterno) {
              miniToastr.success(
                'Mensagem enviada com sucesso!',
                'Sucesso!',
                7000
              )
            } else {
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            }

            this.$router.push({ path: '/mensagens' })
          } else {
            this.disable_buttons = false
            this.erro(response.body.msg)
          }
        })
        .catch((e) => {
          if (e.body.data) {
            this.erro(Object.values(e.body.data)[0])
          }
          console.log(e)
        })
    },
    load (id) {
      Vue.http.get('api/mensagens/' + id).then((response) => {
        this.form.assunto = response.body.data.assunto
        this.form.corpo_email = response.body.data.corpo_email
        this.tp_envios = JSON.parse(response.body.data.tp_envio)
        this.destinatarios = JSON.parse(response.body.data.tb_instituicoes)
        this.arraAnexos = (response.body.data.tb_anexos)
        this.id = response.body.data.id
      })
    },
    clearFiles () {
      this.$refs['file-input'].reset()
      this.imagemAtual = null
      this.DeleteImagens = true
    },
    uploadDoc (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files
      const mimetypes = ['image/bmp', 'image/jpeg', 'image/png', 'image/svg+xml', 'application/pdf']
      if (!arquivo.length) {
        return false
      }
      this.propsAnexo = arquivo[0]
      if (!mimetypes.includes(this.propsAnexo.type)) {
        this.erro('Anexo inválido!')
        this.propsAnexo = null
        return false
      }
      let reader = new FileReader()

      reader.onload = (evento) => {
        this.$v.form.anexo.$model = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    adicionarAnexo () {
      if (this.propsAnexo !== null) {
        this.arraAnexos.push({
          base64: this.$v.form.anexo.$model,
          name: this.propsAnexo.name
        })
      }
    },
    validaForm () {
      if (this.$v.form.corpo_email.$model === '') {
        miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
        miniToastr.error('Corpo do email é obrigatorio!', 'Alerta!', 5000)
        this.descricaoValid = false
        return false
      } else {
        this.descricaoValid = true
      }

      if (this.$v.form.assunto.$model === '') {
        this.erro('Assunto do email é obrigatorio!')
        return false
      }

      if (this.tp_envios.length < 1) {
        this.erro('Ao menos um Tipo de envio deve ser selecionado!')
        return false
      }

      if (this.destinatarios.length < 1 && this.tp_envios.includes(1)) {
        this.erro('Ao menos um destinatário deve ser informado!')
        return false
      }
      return true
    },
    confirmar () {
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja continuar?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            this.salvar()
          }
        })
        .catch((erro) => {
          console.log(erro)
        })
    },
    onSubmit () {
      if (this.validate() && this.validaForm()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    },
    buscaInstituicoes (id) {
      Vue.http.get('api/instituicao?municipio_id=' + id).then(({ data }) => {
        this.instituicoes = data.data.data
      })
    },
    buscaUsuarios () {
      if (this.form.tb_instituicoes.length > 0) {
        let array = []
        this.form.tb_instituicoes.forEach(e => {
          Vue.http.get('api/instituicao/' + e.id).then(({ data }) => {
            const { users } = data.data
            users.map(e => {
              if (this.tp_envios.includes(1) && this.tp_envios.length === 1) {
                if (e.perfil_id === 2 || e.perfil_id === 3) { array.push(e) }
              }
              if (this.tp_envios.includes(1) && this.tp_envios.length > 1) {
                if (this.tp_envios.includes(e.perfil_id)) { array.push(e) }
              }
            })
          })
        })
        this.usuarios = array
      }
    },
    adicionar () {

    },
    download (path) {
      window.open(path, '_blank')
    },
    adicionarDestinatarios () {
      if (this.tp_envios.length < 1) {
        this.erro('Ao menos um tipo de envio deve ser informado!')
        return false
      }

      let array = []
      let names = []
      let emails = []
      if (this.form.tb_instituicoes !== null) {
        this.form.tb_instituicoes.forEach(e => {
          this.form.tb_usuarios.forEach(user => {
            names.push(user.nome)
            emails.push(user.email)
          })
          array.push({
            instituicao_id: e.id,
            categoria: e.categoria,
            cnpj: e.cnpj,
            uf_id: this.form.uf_id,
            municipio_id: this.form.municipio_id,
            municipio_name: this.cidades[this.form.municipio_id],
            nome_instituicao: e.nome_instituicao,
            nomes: names.join(','),
            emails: emails.join(',')
          })
        })
      } else {
        array.push({
          instituicao_id: '',
          categoria: '',
          cnpj: '',
          uf_id: this.form.uf_id,
          municipio_id: this.form.municipio_id,
          municipio_name: this.cidades[this.form.municipio_id],
          nome_instituicao: '',
          nomes: '',
          emails: ''
        })
      }
      this.destinatarios = array.concat(this.destinatarios)
    },
    excluirDestinatario (key) {
      this.destinatarios.splice(key, 1)
    },
    excluirAnexo (key) {
      this.arraAnexos.splice(key, 1)
    },
    erro (msg) {
      miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
      miniToastr.error(msg, 'Alerta!', 5000)
    }
  }
}
</script>

<style scoped>
img.preview {
  width: 200px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/mensages/MensageForm.vue